import { UI } from '../lib/ui.js'
export class Dropdown {
    constructor(){
        const ui = window.ui ? window.ui : new UI
        this.element = ui.element('div',{class:'dropdown-menu dropdown-menu-end'})
    }
    set(items){
        this.element.innerHTML = ''
        items.forEach((item)=>{
            this.element.append(ui.element('li',{},
                ui.element('span',{class:'dropdown-item'},item)
            ))
        })
        return this.element
    }
}